import * as angular from 'angular';
import { integrateUibModelInReact } from 'app/_services/confirm-modal.factory';

(function () {
    'use strict';

    angular.module('app').directive('pkpConfirmOpen', pkpConfirmOpen);

    /**
     * @author bjnowak.btc
     * @ngInject
     */
    function pkpConfirmOpen($uibModal: angular.ui.bootstrap.IModalService) {
        return {
            restrict: 'A',
            scope: {
                modalId: '@pkpConfirmOpen'
            },
            link: postLink
        };

        function postLink(scope, iElement: JQLite) {
            iElement.click(() => {
                const targetModalScope = angular
                    .element('#modal_' + scope.modalId)
                    .scope() as any;

                const modalInstance = $uibModal.open({
                    template:
                        require('app/_directives/pkp-confirm-open.directive.html'),
                    controller: ($scope, $uibModalInstance) => {
                        integrateUibModelInReact($scope, $uibModalInstance);
                    },
                    scope: angular.extend(scope, {
                        id: targetModalScope.id,
                        label: targetModalScope.label,
                        hideTrash: targetModalScope.hideTrash,
                        disabledSend: targetModalScope.disabledSend,
                        modalId: scope.modalId
                    })
                });

                (targetModalScope as ng.IScope).$watch(
                    () => targetModalScope.disabledSend,
                    (newValue) => (scope.disabledSend = newValue)
                );

                modalInstance.rendered.then(() => {
                    angular
                        .element('#' + scope.modalId + 'template')
                        .append(targetModalScope.transclusion);
                });

                modalInstance.result
                    .then(() => targetModalScope.onConfirm())
                    .catch(() => targetModalScope.onClose());
            });
        }
    }
})();
